// Please keep in sync with `QueryInterface::STATUS_*` in back-end.
export enum QueryStatus {
    STATUS_CREATED = 0,
    STATUS_SENT = 1,
    STATUS_RECEIVED = 2,
    STATUS_COMPLETED = 3,
    STATUS_FAILED = 4,
    STATUS_REQUIRED = 5,
}
